import { render } from "./RoomControl.vue?vue&type=template&id=4ffd0cc6&scoped=true"
import script from "./RoomControl.vue?vue&type=script&lang=js"
export * from "./RoomControl.vue?vue&type=script&lang=js"

import "./RoomControl.vue?vue&type=style&index=0&id=4ffd0cc6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ffd0cc6"]])

export default __exports__